<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} </strong></h2>

<ngx-spinner [zIndex]="100" name="spRegistroContable" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content *ngIf="data.accion != accionesDialog.Ver">
  <form [formGroup]="form" *ngIf="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      ¿Esta seguro que desea eliminar el registro <b>{{data.descripcion}}</b>?
    </ng-container>

    <ng-template #formTemplate>
      <mat-tab-group [dynamicHeight]="false" animationDuration="0ms">
        <mat-tab label="Detalle">
          <br>

          <div class="row" *ngIf="data.idExpediente == undefined">
            <div class="col">
              <app-buscar-expediente cdkTrapFocus [cdkTrapFocusAutoCapture]="true"
                (eventEntity)="selectExpediente($event)"></app-buscar-expediente>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-radio-group formControlName="EgresoIngreso">
                <mat-radio-button color="primary" value="1">Ingreso</mat-radio-button>
                <mat-radio-button color="warn" value="-1">Egreso</mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha registro contable</mat-label>
                <input matInput [matDatepicker]="picker1" formControlName="Fecha" />
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-error *ngIf="form.controls['Fecha'].hasError('required')">Este campo es
                  <strong>requerido</strong>.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline" class="w-100">
                <ngx-spinner [zIndex]="-1" name="spTipoRegistroContable" bdColor="rgba(255,255,255,0.8)" size="small"
                  color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <mat-label>Tipo/Concepto</mat-label>
                <mat-select placeholder="Seleccione opcion" formControlName="IdTipoRegistroContable">
                  <mat-option [value]="tipoRegistroContable.id"
                    *ngFor="let tipoRegistroContable of tiposRegistroContable">
                    {{ tipoRegistroContable.descripcion }}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls['IdTipoRegistroContable'].hasError('required')">Este campo es
                  <strong>requerido</strong>.</mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <mat-form-field appearance="outline" class="w-100">
                <ngx-spinner [zIndex]="-1" name="spEstadosRegistroContable" bdColor="rgba(255,255,255,0.8)" size="small"
                  color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <mat-label>Estado</mat-label>
                <mat-select placeholder="Seleccione opcion" formControlName="IdEstadoRegistroContable">
                  <mat-option [value]="estado.id" *ngFor="
                    let estado of estadosRegistroContable;
                    let i = index;
                    trackBy: trackByItems
                  ">
                    {{ estado.descripcion }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <mat-form-field appearance="outline" class="w-100">
                <ngx-spinner [zIndex]="-1" name="spTiposMoneda" bdColor="rgba(255,255,255,0.8)" size="small"
                  color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <mat-label>Moneda Origen</mat-label>
                <mat-select placeholder="Seleccione opcion" formControlName="IdTipoMonedaOrigen">
                  <mat-option [value]="tipoMoneda.id" *ngFor="
                    let tipoMoneda of tiposMoneda;
                    let i = index;
                    trackBy: trackByItems
                  ">
                    {{ tipoMoneda.descripcion }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Importe origen</mat-label>
                <input type="text" mask="separator.2" thousandSeparator="." decimalMarker=","
                  placeholder="Valor de tipo de cambio" formControlName="ImporteMonedaOrigen" matInput />
                <mat-error *ngIf="form.controls['Importe'].hasError('required')">Este campo es
                  <strong>requerido</strong>.</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-4">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Cotización</mat-label>
                <input type="text" mask="separator.2" thousandSeparator="." decimalMarker=","
                  placeholder="Es el tipo de cambio aplicado para convertir de moneda origen a moneda local."
                  formControlName="CotizacionMonedaOrigen" matInput />
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-6">
              <mat-form-field appearance="outline" class="w-100">
                <ngx-spinner [zIndex]="-1" name="spTiposMoneda" bdColor="rgba(255,255,255,0.8)" size="small"
                  color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <mat-label>Moneda Local</mat-label>
                <mat-select placeholder="Moneda en la que la empresa o sistema registra contablemente los valores"
                  formControlName="IdTipoMonedaLocal">
                  <mat-option [value]="tipoMoneda.id" *ngFor="
                    let tipoMoneda of tiposMoneda;
                    let i = index;
                    trackBy: trackByItems
                  ">
                    {{ tipoMoneda.descripcion }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Importe</mat-label>
                <input type="text" mask="separator.2" thousandSeparator="." decimalMarker="," placeholder=""
                  formControlName="Importe" matInput />
                <mat-error *ngIf="form.controls['Importe'].hasError('required')">Este campo es
                  <strong>requerido</strong>.</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">


            <div class="col-lg-6">
              <mat-form-field appearance="outline" class="w-100">
                <ngx-spinner [zIndex]="-1" name="spCuentaCaja" bdColor="rgba(255,255,255,0.8)" size="small"
                  color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <mat-label>Cuentas Cajas</mat-label>
                <mat-select placeholder="Seleccione opcion" formControlName="IdCuentaCaja">
                  <mat-option [value]="cuentaCaja.id" *ngFor="
                    let cuentaCaja of cuentasCaja;
                    let i = index;
                    trackBy: trackByItems
                  ">
                    {{ cuentaCaja.descripcion }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-lg-6">
              <mat-form-field appearance="outline" class="w-100">
                <ngx-spinner [zIndex]="-1" name="spCuentaContable" bdColor="rgba(255,255,255,0.8)" size="small"
                  color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
                <mat-label>Cuenta Contable</mat-label>
                <mat-select placeholder="Seleccione opcion" formControlName="IdCuentaContable">
                  <mat-option [value]="cuentaContables.id" *ngFor="
                    let cuentaContables of cuentasContables;
                    let i = index;
                    trackBy: trackByItems
                  ">
                    {{ cuentaContables.descripcion }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12">

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Observaciones</mat-label>
                <textarea matInput formControlName="Observaciones" maxlength="500"></textarea>
                <mat-hint align="end">{{ form.get('Observaciones')?.value?.length || 0 }} / 500</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Más info..">
          <br>

          <div class="row">
            <div class="col-lg-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Origen</mat-label>
                <input type="text" placeholder="Origen" formControlName="Origen" matInput />
              </mat-form-field>
            </div>

            <div class="col-lg-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Referencia externa</mat-label>
                <input type="text" placeholder="Referencia externa" formControlName="ReferenciaExterna" matInput />
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <app-select-usuarios-empresa [idUsuarioIngresado]="this.registroContable.aprobadoPor?.id"
                [label]="'Aprobado por'"
                (usuarioSeleccionado)="onUsuarioSeleccionado($event)"></app-select-usuarios-empresa>
              <!-- <mat-form-field appearance="outline" class="w-100">
                <mat-label>Aprobado por</mat-label>
                <input type="text" placeholder="Aprobación de usuario" formControlName="AprobadoPor" matInput />
              </mat-form-field> -->
            </div>
            <div class="col-lg-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Fecha Aprobación</mat-label>
                <input type="date" placeholder="Fecha de aprobación" formControlName="FechaAprobacion" matInput />
              </mat-form-field>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>

    </ng-template>
  </form>
</mat-dialog-content>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">

  <div *ngIf="registroContable">

    <div class="row">
      <div class="col">
        <!-- Información General -->
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Información General</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Descripción:</span> {{ registroContable.descripcion }}
            </div>
            <div class="property-row"><span class="property-name">Observaciones:</span> {{
              registroContable.observaciones }}
            </div>
            <div class="property-row"><span class="property-name">Etiqueta:</span> {{ registroContable.etiqueta }}</div>
            <div class="property-row"><span class="property-name">Referencia Externa:</span> {{
              registroContable.referenciaExterna }}</div>
            <div class="property-row"><span class="property-name">Origen:</span> {{ registroContable.origen }}</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col">
        <!-- Fechas -->
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Fechas</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Fecha:</span> {{ registroContable.fecha | date }}
            </div>
            <div class="property-row"><span class="property-name">Fecha Alta:</span> {{ registroContable.fechaAlta |
              date }}
            </div>
            <div class="property-row"><span class="property-name">Fecha Modificación:</span> {{
              registroContable.fechaModificacion | date }}</div>
            <div class="property-row"><span class="property-name">Fecha Aprobación:</span> {{
              registroContable.fechaAprobacion
              | date }}</div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col">
        <!-- Datos Monetarios -->
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Datos Monetarios</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Importe:</span> {{ registroContable.importe | currency
              }}
            </div>
            <div class="property-row"><span class="property-name">Importe Moneda Origen:</span> {{
              registroContable.importeMonedaOrigen | currency }}</div>
            <div class="property-row"><span class="property-name">Cotización Moneda Origen:</span> {{
              registroContable.cotizacionMonedaOrigen }}</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col">
        <!-- Tipo de Registro y Moneda -->
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Tipo y Moneda</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Tipo de Registro:</span> {{
              registroContable.tipoRegistroContable?.descripcion }}</div>
            <div class="property-row"><span class="property-name">Moneda Origen:</span> {{
              registroContable.tipoMonedaOrigen?.descripcion }}</div>
            <div class="property-row"><span class="property-name">Moneda Local:</span> {{
              registroContable.tipoMonedaLocal?.descripcion }}</div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col">
        <!-- Estado y Aprobador -->
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Estado y Aprobador</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Estado:</span> {{
              registroContable.estadoRegistroContable?.descripcion }}</div>
            <div class="property-row"><span class="property-name">Aprobado Por:</span> {{
              registroContable.aprobadoPor?.nombre
              }} {{ registroContable.aprobadoPor?.apellido }}</div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col">
        <!-- Referencias -->
        <mat-card appearance="outlined">
          <mat-card-header>
            <mat-card-title>Referencias</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="property-row"><span class="property-name">Expediente:</span> <a
                [routerLink]="['/expediente', registroContable.expediente?.id]">
                {{ registroContable.expediente?.identificadorUnico }}
              </a></div>
            <!-- <div class="property-row"><span class="property-name">Cuenta Caja:</span> {{
              registroContable.cuentaCaja?.descripcion }}</div>
            <div class="property-row"><span class="property-name">Planilla Caja:</span> {{
              registroContable.planillaCaja?.descripcion }}</div> -->
          </mat-card-content>
        </mat-card>
      </div>
    </div>

  </div>

</mat-dialog-content>


<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form?.valid"
    (click)="agregar()"></app-button-add>

  <app-button-save [disabled]="!form?.valid" [isDialogClose]="true" (saveClicked)="modificar()"
    (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Modificar"></app-button-save>

  <app-button-delete (click)="eliminar()" (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Eliminar"
    [isDialogClose]="true"></app-button-delete>
</mat-dialog-actions>
